document.addEventListener('DOMContentLoaded', () => {
    let isInitialized = false;

    function setup(button, content, isOpen) {
        button.setAttribute('aria-expanded', isOpen);
        if (isOpen) {
            content.setAttribute('aria-hidden', true);
        }
        content.style.maxHeight = isOpen ? `${content.scrollHeight}px` : '0';
    }

    function init() {
        document.querySelectorAll('.footer_nav').forEach(accordion => {
            const button = accordion.querySelector('.footer_nav_title');
            const content = accordion.querySelector('.footer_nav_list');
            const isOpen = accordion.classList.contains('open');

            setup(button, content, isOpen);

            button.setAttribute('role', 'button');
            button.setAttribute('tabindex', '0');

            if (!button.dataset.accordionBound) {
                button.addEventListener('click', () => {
                    document.querySelectorAll('.footer_nav').forEach(otherAccordion => {
                        if (otherAccordion !== accordion && otherAccordion.classList.contains('open')) {
                            const otherButton = otherAccordion.querySelector('.footer_nav_title');
                            const otherContent = otherAccordion.querySelector('.footer_nav_list');
                            otherAccordion.classList.remove('open');
                            setup(otherButton, otherContent, false);
                        }
                    });
                    const nowOpen = accordion.classList.toggle('open');
                    setup(button, content, nowOpen);
                });

                button.addEventListener('keydown', e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        button.click();
                    }
                });

                button.dataset.accordionBound = 'true';
            }
        });

        isInitialized = true;
    }

    function handleResize() {
        if (window.innerWidth <= 1024) {
            if (!isInitialized) init();
        } else {
            document.querySelectorAll('.footer_nav').forEach(accordion => {
                accordion.classList.remove('open');
                const content = accordion.querySelector('.footer_nav_list');
                content.style.maxHeight = 'none';
                content.removeAttribute('aria-hidden');
            });
            isInitialized = false;
        }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
});
